export enum QueryKeys {
  ImagesByMedia = "imagesByMedia",
  Notifications = "notifications",
  Article = "article",
  ArticlesByGroup = "articlesByGroup",
  ArticlesByMediaAndProductArticleId = "articlesByMediaAndProductArticleId",
  ArticlesByMedia = "articlesByMedia",
  Medias = "medias",
  Media = "media",
  MessageNotifications = "messageNotifications",
  GroupsByMedia = "groupsByMedia",
  EdsData = "edsData",
  Group = "group",
  SignedUrl = "signedUrl",
  MediasAndArticleCount = "mediasAndArticleCount",
  SalesStopData = "salesStopData",
  SearchArticlesInMedias = "searchArticlesInMedias",
  TaskLinksByArticle = "taskLinksByArticle",
  TaskLinksByMedia = "taskLinksByMedia",
  TaskLinksByStore = "taskLinksByStore",
  CombinationArticle = "combinationArticle",
}
